import { makeStyles } from '@material-ui/core/styles';
import transitions from '@material-ui/core/styles/transitions';
const useStyles = makeStyles((theme) => ({
  project: {

    '& .empty-project': {
      background: '#d2d8e7',
      borderTopLeftRadius: `${theme.spacer}px`,
      borderTopRightRadius: `${theme.spacer}px`
    },
    "& .projects-li img": {
      borderTopRightRadius: `${theme.spacer}px`,
      borderTopLeftRadius: `${theme.spacer}px`,
      height: "100%",
      width: "100%",
      position: "absolute"
    },
    "& .projects-li span": {
      borderTopRightRadius: `${theme.spacer}px`,
      borderTopLeftRadius: `${theme.spacer}px`,
      height: "100%",
      width: "100%",
      cursor:"pointer !important",
      position: "absolute",
      border: "none",
      overflow:'hidden',
      boxSizing: 'content-box',
      "& svg":{
        minWidth:'969px !important',
        minHeight: '586px !important',
        backgroundColor:"#d2d8e7 !important",
        "& rect": {
          fill: "#DCE1EC"
        },
        "& path":{
          stroke: "#BFC8DD",
        },
        '& image[*|href*="addLane"]': {
         visibility:'hidden'  
        }
      }
    },
    "& .projects-li": {
      padding: "0px 0px 0px 0px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
      width: `${theme.spacer * 36.25}px`,
      borderRadius: `${theme.spacer}px`,
      background: theme.color.white,
      height: `${theme.spacer * 29}px`,
      marginTop: "0px",
      marginRight: "0px",
      marginLeft: "0px",

   
      "& @include mobile-s": { width: "100%", marginRight: "0" },
      "& @include mobile-l": { width: "100%", marginRight: "0" },
      "& @include mobile-m": { width: "100%", marginRight: "0" },
      "& @include tablet-all": { width: "100%", marginRight: "0" },
      "& @include laptop-s": { width: "100%", marginRight: "0" }
    },
    '& .empty': {
      background: '#d2d8e7'
    },
    "& .projects-li a:hover":
    {
      textDecoration: "none"
    },
    "& .projects-li-head":
    {
      $fontWeight: "500",
      fontWeight: "$font-weight"
    },
    "& .projects-li .grid-1": {
      margin: "0",
      padding: "0",
      height: `${theme.spacer * 22}px`,
      position: "relative"
    },
    "& .projects-li .grid-2": {
      margin: "0px",
      display: "grid",
      gridTemplateColumns: "90% 10%",
      height: `${theme.spacer * 7}px`,
    },
    "& .projects-li .grid-2 .menu-bar": {
      marginLeft: `${theme.spacer * -0.5}px`,
      marginTop: `${theme.spacer * 2}px`,
      // cursor: "pointer",                           //commented due to no actions on more
      color: theme.color.gray40
    },
    "& .projects-li .grid-2 .name-bar":
    {
      marginTop: `${theme.spacer}px`,
      paddingLeft: `${theme.spacer * 2}px`,
      lineHeight: `${theme.spacer * 3}px`,
      '& .modernize-label':{
        color: theme.color.blue60,
        fontWeight: '500',
        fontSize: '13px',

      },
    },
    "& .prj_name": {
      $fontWeight: "500",
      fontWeight: "$font-weight",
      fontSize: "16px",
      marginBottom: `${-theme.spacer}px`,
      marginTop: "0",
      overflowWrap: "break-word",
      overflowY:"hidden",
      height: "25px",
      color: "black"
    },
      "& .prj_name_restore": {
      $fontWeight: "500",
      fontWeight: "$font-weight",
      fontSize: "16px",
      marginBottom: `${-theme.spacer}px`,
      marginTop: "0",
      overflowWrap: "anywhere",
      overflowY:"hidden",
      height: "25px",
      color: theme.color.red60
    },
    "& .proj-time": 
    {
      marginTop: "0px !important",
      height: "14px",
      marginRight: "8px"
    },
    "& .new_commit": {
  
      marginLeft: "4px",
      fontSize: "13px",
      marginBottom: `${-theme.spacer}px`,
      marginTop: "0px",
      color: "#0062FF",
    },
    "& .new_commit_dot": {
     height:"8px",
     width:"8px",
     backgroundColor: "#0062FF",
     borderRadius:"4px",
     marginTop: "8px",
    },
    "& .projects-li .grid-2 label": {
      fontSize: "11px",
      color: "#A4A4A4",
      marginTop: `${theme.spacer * -4}px`,
      "& body":{
        lineHeight: "0px"
      }
    },
    "& .inner-box>.row-1,.inner-box>.row-2,.inner-box>.row-3": {
      marginTop: "0px !important",
      width: "-webkit-fill-available",
      borderBottom: "1px solid #f0f2f773",
      display: "flex",
      alignItems: "flex-start",
      position: "relative"
    },
    "& .inner-box>.row-restore": {
      marginTop: "0px !important",
      width: "-webkit-fill-available",
      borderBottom: "0px solid #f0f2f773",
      display: "flex",
      alignItems: "flex-start",
      position: "relative"
      
    },
    
    "& .inner-box>.row:last-child": {
      borderBottom: "unset"
    },
    "& .inner-box>.row-1,.inner-box>.row-restore": {
      height: "40%",
      alignItems : "center",
      paddingLeft: `${theme.spacer * 2}px`,
      fontSize: "16px",
      $fontWeight: "500",
      fontWeight: "$font-weight"
    },
    "& .inner-box>.row-2,.inner-box>.row-3,.inner-box>.row-3,.inner-box>.row-4": {
      height: "20%",
      alignItems : "center",
      fontSize: "13px",
      $fontWeight: "500",
      fontWeight: "$font-weight"
    },
    "& .inner-box": {
      fontSize: "13px"
    },
    "& .topright-arrow": {
      marginLeft: `${theme.spacer * 2}px`,
      marginTop: "0px",
      marginRight: `${theme.spacer}px`,
      height: `${theme.spacer * 2}px`,
      width: `${theme.spacer * 2}px`,
    },
    "& .inner-box>.row-1>.right-carat,.inner-box>.row-restore": {
      marginTop: "0px",
      paddingTop: "0px",
      marginRight: "4px",
      marginLeft: "auto",
    
    },
    "& .right-carat": {
      marginTop: "0px",
      paddingTop: "0px",
      marginLeft: "auto",
      marginRight: "4px",
      position: "relative",
      color: theme.color.coolgray10,
    },
    "& .inner-box": {
      cursor: "pointer",
      background: "#9fadcb85",
      width: "100%",
      borderTopLeftRadius: "5px",
      borderTopRightRadius: "5px",
      position: "relative",
      backgroundColor: "rgba(139, 155, 192, 0.8)",
      height: `${theme.spacer * 22}px`,
      paddingLeft: "0px",
      paddingRight: "0px",
      color: "white",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
 
  }
}));
export default useStyles;